"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDnd = require("react-dnd");
var _reactDom = _interopRequireDefault(require("react-dom"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _throttle2 = _interopRequireDefault(require("lodash/throttle"));
var _config = require("./config.js");
var _document = _interopRequireDefault(require("./document.png"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var timeouts = {};
var clearTimeouts = function clearTimeouts() {
  // Clear all timeouts
  (0, _forEach2["default"])(timeouts, function (timeout, key) {
    clearTimeout(timeout);
    delete timeouts[key];
  });
};
var source = {
  beginDrag: function beginDrag(props, monitor, component) {
    return {
      element: props.element
    };
  }
};
var target = {
  hover: (0, _throttle2["default"])(function (props, monitor, component) {
    var element = props.element,
      toggleCollapsedElementState = props.toggleCollapsedElementState;

    // Determine rectangle on screen
    var hoverBoundingRect = _reactDom["default"].findDOMNode(component).getBoundingClientRect();

    // Get horizontal middle
    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    var hoverLowQuarterY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 4;
    var hoverHighQuarterY = (hoverBoundingRect.bottom - hoverBoundingRect.top) * 3 / 4;

    // Determine mouse position
    var clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    var hoverClientY = clientOffset.y - hoverBoundingRect.top;
    var middle = hoverClientY >= hoverLowQuarterY && hoverClientY <= hoverHighQuarterY;
    var hoveredElement = {
      id: element.id,
      top: hoverClientY < hoverMiddleY,
      middle: middle,
      bottom: hoverClientY >= hoverMiddleY
    };
    var prevHoveredElement = (0, _pick2["default"])(props.hoveredElement, ['id', 'top', 'middle', 'bottom']);
    if (!(0, _isEqual2["default"])(prevHoveredElement, hoveredElement)) {
      props.hoverElement(hoveredElement);
    }
    if (props.isCollapsed) {
      if (middle && !timeouts[element.id]) {
        timeouts[element.id] = setTimeout(function () {
          toggleCollapsedElementState(element.id);
        }, _config.HOVER_EXPAND_WAITING);
      }
      if (!middle) {
        clearTimeouts();
      }
    }
  }, 1000 / 30, {
    trailing: false
  }),
  drop: function drop(props, monitor, component) {
    clearTimeouts();
  }
};
function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}
function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}
var Element = /*#__PURE__*/function (_React$Component) {
  function Element() {
    var _this;
    _classCallCheck(this, Element);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Element, [].concat(args));
    _defineProperty(_this, "_toggleCollapsedElementState", function () {
      _this.props.toggleCollapsedElementState(_this.props.element.id);
    });
    _defineProperty(_this, "_getElement", function () {
      var _this$props = _this.props,
        element = _this$props.element,
        isDragging = _this$props.isDragging,
        isCollapsed = _this$props.isCollapsed,
        connectDragSource = _this$props.connectDragSource,
        collapsedIndent = _this$props.collapsedIndent,
        isPlaceholderParent = _this$props.isPlaceholderParent;
      if (isDragging) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingLeft: "".concat((element.level - 1) * _this.props.indentSize, "px")
        }
      }, connectDragSource(/*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].elementWrapper,
        style: {
          marginLeft: "".concat(collapsedIndent, "px")
        }
      }, element.isAdult && element.children && element.children.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].collapsed,
        onClick: _this._toggleCollapsedElementState
      }, isCollapsed ? /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), element.isAdult && (!element.children || element.children.length === 0) && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].collapsed + ' ' + _style["default"].disabled
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: isPlaceholderParent ? _style["default"].placeholderParent : ''
      }, element.component))));
    });
    return _this;
  }
  _inherits(Element, _React$Component);
  return _createClass(Element, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var img = new Image();
      img.src = _document["default"];
      img.onload = function () {
        return _this2.props.connectDragPreview(img);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var connectDropTarget = this.props.connectDropTarget;
      return connectDropTarget(/*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative'
        }
      }, this._getElement()));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Element, "propTypes", {
  connectDropTarget: _propTypes["default"].func.isRequired,
  connectDragSource: _propTypes["default"].func.isRequired,
  connectDragPreview: _propTypes["default"].func.isRequired,
  isDragging: _propTypes["default"].bool.isRequired,
  element: _propTypes["default"].object,
  indentSize: _propTypes["default"].number,
  isCollapsed: _propTypes["default"].bool,
  hoveredElement: _propTypes["default"].object,
  hoverElement: _propTypes["default"].func,
  toggleCollapsedElementState: _propTypes["default"].func,
  collapsedIndent: _propTypes["default"].number,
  isPlaceholderParent: _propTypes["default"].bool
});
var _default = exports["default"] = (0, _reactDnd.DropTarget)(function (props) {
  return props.dragDropType;
}, target, collectTarget)((0, _reactDnd.DragSource)(function (props) {
  return props.dragDropType;
}, source, collectSource)(Element));